/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CheckPhoneResponse } from '../../entities/v1/CheckPhoneResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1DriverSegmentSchema } from './driverSegmentSchema'
import { v1UserTypeSchema } from './userTypeSchema'
import { z } from 'zod'

export const v1CheckPhoneResponseSchema = z.object({
  driver_segment: z.lazy(() => v1DriverSegmentSchema),
  user_type: z.lazy(() => v1UserTypeSchema),
}) as unknown as ToZod<V1CheckPhoneResponse>